"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withIcon = _interopRequireDefault(require("../withIcon"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const IconHouseOutline = props => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
    viewBox: "0 0 20 17",
    ...props,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M10,0 L14,3.6 L14,1 L17,1 L17,6.3 L20,9 L17,9 L17,17 L11,17 L11,11 L9,11 L9,17 L3,17 L3,9 L0,9 L10,0 Z M10,2.287 L4.7,7.3 L4.7,15.3 L7.3,15.3 L7.3,9.3 L12.7,9.3 L12.7,15.3 L15.3,15.3 L15.3,7.3 L10,2.287 Z"
    })
  });
};
var _default = exports.default = (0, _withIcon.default)('IconHouseOutline')(IconHouseOutline);